/** @file Presence `editing` (E8-R7): the first selected bone, slot, keyed animation or vertex attachment. */
import type { Doc } from '@pose2d/format/types';
import type { SelectionSlice } from '../../stores/types';

/** undefined when nothing of this kind is selected; else the entity's name, or null when the id is not in the doc. */
const nameIn = (table: Readonly<Record<string, { name: string }>>, id: string | undefined): string | null | undefined =>
  id === undefined ? undefined : (table[id]?.name ?? null);

/** The entity name this client is editing, or null; the first kind with a selection decides. */
export function editingName(doc: Doc | null, selection: SelectionSlice): string | null {
  if (doc === null) return null;
  const found = [
    nameIn(doc.bones, selection.bones[0]),
    nameIn(doc.slots, selection.slots[0]),
    nameIn(doc.animations, selection.keys[0]?.animation),
    nameIn(doc.attachments, selection.vertices[0]?.[0]),
  ].find((name) => name !== undefined);
  return found ?? null;
}
